<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="pz11-1"><b>CONTENTS</b></h1>
<p class="cct12" id="pz11-2"><a href="#/chapter02#bb_02" id="aa_02"><i>Introduction</i></a></p>
<p class="cct" id="pz11-3"><a href="#/chapter03#bb_03" id="aa_03">ONE: Wrong Church, Wrong People, Wrong Day</a></p>
<p class="cct" id="pz11-4"><a href="#/chapter04#bb_04" id="aa_04">TWO: Forgiveness</a></p>
<p class="cct" id="pz11-5"><span href="#/chapter05#bb_05" id="aa_05" title="Link target outside of Sample">THREE: The Flag Comes Down</span></p>
<p class="cct" id="pz11-6"><span href="#/chapter06#bb_06" id="aa_06" title="Link target outside of Sample">FOUR: The Sin of Slavery</span></p>
<p class="cct" id="pz11-7"><span href="#/chapter07#bb_07" id="aa_07" title="Link target outside of Sample">FIVE: Revolutionary Ideas and the Rise of African Methodism</span></p>
<p class="cct" id="pz11-9"><span href="#/chapter08#bb_08" id="aa_08" title="Link target outside of Sample">SIX: The Slave Conspiracy</span></p>
<p class="cct" id="pz11-10"><span href="#/chapter09#bb_09" id="aa_09" title="Link target outside of Sample">SEVEN: Resurrection</span></p>
<p class="cct" id="pz11-11"><span href="#/chapter10#bb_10" id="aa_10" title="Link target outside of Sample">EIGHT: Jim Crow</span></p>
<p class="cct" id="pz11-12"><span href="#/chapter11#bb_11" id="aa_11" title="Link target outside of Sample">NINE: Life in the Borough</span></p>
<p class="cct" id="pz11-13"><span href="#/chapter12#bb_12" id="aa_12" title="Link target outside of Sample">TEN: Civil Rights</span></p>
<p class="cct" id="pz11-14"><span href="#/chapter13#bb_13" id="aa_13" title="Link target outside of Sample">ELEVEN: People in Service to the Church</span></p>
<p class="cct" id="pz11-15"><span href="#/chapter14#bb_14" id="aa_14" title="Link target outside of Sample">TWELVE: What Is Forgiveness?</span></p>
<p class="cct" id="pz11-16"><span href="#/chapter15#bb_15" id="aa_15" title="Link target outside of Sample">THIRTEEN: The Unfinished Story</span></p>
<p class="cct11" id="pz11-17"><span href="#/chapter16#bb_16" id="aa_16" title="Link target outside of Sample"><i>Epilogue</i></span></p>
<p class="cct1" id="pz11-18"><span href="#/chapter17#bb_17" id="aa_17" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="cct1" id="pz11-19"><span href="#/chapter18#bb_18" id="aa_18" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="cct1" id="pz11-20"><span href="#/chapter19#bb_19" id="aa_19" title="Link target outside of Sample"><i>About the Authors</i></span></p>
<p class="cct1" id="pz11-20a"><span href="#/chapter20#bb_20" id="aa_20" title="Link target outside of Sample"><i>Photos</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?693fe156